import { View } from "react-native";
import {
  IconButton,
  Text,
  TouchableRipple,
  useTheme,
} from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useProductFormNavigation from "../hooks/useProductFormNavigation";
import { productFormRoutes } from "../navigation/types";

export default function ManageVariantsInventory() {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  const { navigate } = useProductFormNavigation();

  return (
    <TouchableRipple
      onPress={() => navigate(productFormRoutes.variantCombinations)}
    >
      <View style={tailwind("flex-row items-center")}>
        <View style={tailwind("flex-1")}>
          <Text variant="titleMedium">Manejar inventario por variantes</Text>
          <Text variant="bodyMedium">
            Maneja el inventario de las opciones de cada variante aquí.
          </Text>
        </View>

        <IconButton icon="menu-right" iconColor={colors.primary} />
      </View>
    </TouchableRipple>
  );
}
